const API_BASE = import.meta.env.VITE_API_URL ?? 'https://api.theonestack.com';

// Ensure all paths are routed through the people service prefix unless they
// already carry a different service prefix (people/ or legal/).
function resolveApiPath(path: string): string {
  if (!path) return path;
  if (path.startsWith('people/') || path.startsWith('legal/')) return path;
  return `people/${path}`;
}

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}/api/${resolveApiPath(path)}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (res.status === 401) {
    sessionStorage.setItem('returnUrl', window.location.pathname);
    window.location.href = `https://app.theonestack.com/login?redirect=people`;
    return new Promise<T>(() => {});
  }

  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error ?? `HTTP ${res.status}`);
  }

  return res.json();
}

export const get = <T>(path: string) => api<T>(path);
export const post = <T>(path: string, body: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(body) });
export const put = <T>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body: JSON.stringify(body) });
export const patch = <T>(path: string, body: unknown) => api<T>(path, { method: 'PATCH', body: JSON.stringify(body) });
export const del = <T>(path: string) => api<T>(path, { method: 'DELETE' });
